import { IAppState } from 'config/redux/reducers';
import { useSelector } from 'react-redux';

const useLocationCx = (): boolean => {
  const {
    appConfig: { features = {} },
  } = useSelector((state: IAppState) => state);
  const { isLocationCXEnable = false } = features;
  return isLocationCXEnable;
};

export default useLocationCx;
